/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { batchActions } from 'redux-batched-actions/lib/index';
// actions
import { displayModal } from '@insticator/insticator-ui'; // iui-state
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { getClientEmbedsData } from 'state/actions/embedsState/embeds_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { resetEmbedState, getEmbedCode } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import CodePage from 'pages/dashboard/embeds/management/code/code';



/* ========== ~~~~~~~~~~ EMBED CODE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    siteUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.siteUUID,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    bodyCode: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.bodyCode,
    headerCode: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.headerCode
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    moveToEmbedCreationWithStateReset: () => {
        dispatch(batchActions([
            resetEmbedState(),
            resetContentState({ setInitialContentId: true }),
        ]));
        dispatch(updatePageDetails('dashboard/embeds/management/getstarted'));
        dispatch(updateStepDetails('getstarted'));
        dispatch(changePage('dashboard/embeds/management/getstarted'))
    },
    getEmbedCode: (siteUUID, embedUUID) => dispatch(getEmbedCode(siteUUID, embedUUID)),
    getClientEmbedsData: accountUUID => dispatch(getClientEmbedsData(accountUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(CodePage);
